
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 47.62 47.62"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Camada 2"}},[_c('g',{attrs:{"data-name":"Camada 1"}},[_c('circle',{attrs:{"cx":"23.81","cy":"23.81","r":"23.81","fill":"#567bbd"}}),_c('path',{attrs:{"d":"M32.37 24.71a1.28 1.28 0 001.06-2.19l-8.72-8.72a1.29 1.29 0 00-.91-.38 1.31 1.31 0 00-.92.38l-8.69 8.69a1.3 1.3 0 000 1.83 1.29 1.29 0 001 .37v8.22a1.3 1.3 0 001.3 1.29h14.59a1.29 1.29 0 001.29-1.29z","fill":"#fff"}})])])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/network_module/object_forms/building.svg